export enum MaintenanceTaskStatus {
	Canceled = 'Canceled',
	Completed = 'Completed',
	Review = 'Review',
	InProgress = 'In Progress',
	Pending = 'Pending',
	Blocked = 'Blocked',
}
